import xml from "csi/xml";
import React, { FunctionComponent } from "react";
import { VALUE_TYPE } from "src/c8-platform/type/value";

const { BOOLEAN, STRING } = VALUE_TYPE;
const NUMERIC = "Numeric";

export const AlphabeticalAscendingIcon: FunctionComponent = (props) => {
	return (
		<svg
			fill="none"
			height="16"
			viewBox="0 0 16 16"
			width="16"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g id="sort-alphabetical-ascending">
				<path
					d="M12.6666 11.3333H14.6666L11.9999 14L9.33325 11.3333H11.3333V2H12.6666M7.33325 8.66667V10L5.11325 12.6667H7.33325V14H3.33325V12.6667L5.55325 10H3.33325V8.66667M5.99992 2H4.66659C3.93325 2 3.33325 2.6 3.33325 3.33333V7.33333H4.66659V6H5.99992V7.33333H7.33325V3.33333C7.33325 2.6 6.73992 2 5.99992 2ZM5.99992 4.66667H4.66659V3.33333H5.99992V4.66667Z"
					fill="black"
					id="Vector"
				/>
			</g>
		</svg>
	);
};

export const AlphabeticalDescendingIcon: FunctionComponent = (props) => {
	return (
		<svg
			fill="none"
			height="16"
			viewBox="0 0 16 16"
			width="16"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M12.6666 4.66667H14.6666L11.9999 2L9.33325 4.66667H11.3333V14H12.6666M7.33325 8.66667V10L5.11325 12.6667H7.33325V14H3.33325V12.6667L5.55325 10H3.33325V8.66667M5.99992 2H4.66659C3.93325 2 3.33325 2.6 3.33325 3.33333V7.33333H4.66659V6H5.99992V7.33333H7.33325V3.33333C7.33325 2.6 6.73992 2 5.99992 2ZM5.99992 4.66667H4.66659V3.33333H5.99992V4.66667Z" fill="black" />
		</svg>
	);
};

export const NumericalDescendingIcon: FunctionComponent = (props) => {
	return (
		<svg
			fill="none"
			height="16"
			viewBox="0 0 16 16"
			width="16"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M12.6666 4.66667H14.6666L11.9999 2L9.33325 4.66667H11.3333V14H12.6666M5.99992 14H3.33325V12.6667H5.99992V12H4.66659C3.93325 12 3.33325 11.4067 3.33325 10.6667V10C3.33325 9.26667 3.93325 8.66667 4.66659 8.66667H5.99992C6.73992 8.66667 7.33325 9.26667 7.33325 10V12.6667C7.33325 13.4067 6.73992 14 5.99992 14ZM5.99992 10H4.66659V10.6667H5.99992M4.66659 2H5.99992C6.73992 2 7.33325 2.6 7.33325 3.33333V6C7.33325 6.74 6.73992 7.33333 5.99992 7.33333H4.66659C3.93325 7.33333 3.33325 6.74 3.33325 6V3.33333C3.33325 2.6 3.93325 2 4.66659 2ZM4.66659 6H5.99992V3.33333H4.66659V6Z" fill="black" />
		</svg>
	);
};

export const NumericalAscendingIcon: FunctionComponent = (props) => {
	return (
		<svg
			fill="none"
			height="16"
			viewBox="0 0 16 16"
			width="16"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g id="sort-numeric-ascending">
				<path
					d="M12.6666 11.3333H14.6666L11.9999 14L9.33325 11.3333H11.3333V2H12.6666V11.3333ZM5.99992 8.66667H4.66659C3.93325 8.66667 3.33325 9.26667 3.33325 10V10.6667C3.33325 11.4067 3.93325 12 4.66659 12H5.99992V12.6667H3.33325V14H5.99992C6.73992 14 7.33325 13.4067 7.33325 12.6667V10C7.33325 9.26667 6.73992 8.66667 5.99992 8.66667ZM5.99992 10.6667H4.66659V10H5.99992V10.6667ZM5.99992 2H4.66659C3.93325 2 3.33325 2.6 3.33325 3.33333V6C3.33325 6.74 3.93325 7.33333 4.66659 7.33333H5.99992C6.73992 7.33333 7.33325 6.74 7.33325 6V3.33333C7.33325 2.6 6.73992 2 5.99992 2ZM5.99992 6H4.66659V3.33333H5.99992V6Z"
					fill="black"
					id="Vector"
				/>
			</g>
		</svg>
	);
};

export const BooleanDescendingIcon: FunctionComponent = (props) => {
	return (
		<svg
			fill="none"
			height="16"
			viewBox="0 0 16 16"
			width="16"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g id="sort-bool-descending-variant">
				<path
					d="M12.6667 4.66667H14.6667L12 2L9.33333 4.66667H11.3333V14H12.6667M3.33333 8.66667C2.59333 8.66667 2 9.26 2 10V12.6667C2 13.4067 2.59333 14 3.33333 14H6C6.74 14 7.33333 13.4067 7.33333 12.6667V10C7.33333 9.26 6.74 8.66667 6 8.66667M6.13333 9.66667L6.84 10.3667L4.18 13L2.49333 11.3L3.20667 10.6L4.18667 11.5933M3.33333 2C2.59333 2 2 2.59333 2 3.33333V6C2 6.74 2.59333 7.33333 3.33333 7.33333H6C6.74 7.33333 7.33333 6.74 7.33333 6V3.33333C7.33333 2.59333 6.74 2 6 2M3.33333 3.33333H6V6H3.33333V3.33333Z"
					fill="black"
					id="Vector"
				/>
			</g>
		</svg>
	);
};

export const BooleanAscendingIcon: FunctionComponent = (props) => {
	return (
		<svg
			fill="none"
			height="16"
			viewBox="0 0 16 16"
			width="16"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g id="sort-bool-ascending-variant">
				<path
					d="M12.6667 11.3333H14.6667L12 14L9.33333 11.3333H11.3333V2H12.6667V11.3333ZM6 8.66667H3.33333C2.59333 8.66667 2 9.26 2 10V12.6667C2 13.4067 2.59333 14 3.33333 14H6C6.74 14 7.33333 13.4067 7.33333 12.6667V10C7.33333 9.26 6.74 8.66667 6 8.66667ZM4.18 13L2.49333 11.3L3.20667 10.6L4.18667 11.5933L6.13333 9.66667L6.84 10.3667L4.18 13ZM6 2H3.33333C2.59333 2 2 2.59333 2 3.33333V6C2 6.74 2.59333 7.33333 3.33333 7.33333H6C6.74 7.33333 7.33333 6.74 7.33333 6V3.33333C7.33333 2.59333 6.74 2 6 2ZM6 6H3.33333V3.33333H6V6Z"
					fill="black"
					id="Vector"
				/>
			</g>
		</svg>
	);
};

const ASCENDING_ICONS: Record<string, FunctionComponent> = {
	[BOOLEAN]: BooleanAscendingIcon,
	[NUMERIC]: NumericalAscendingIcon,
	[STRING]: AlphabeticalAscendingIcon,
};

const DESCENDING_ICONS: Record<string, FunctionComponent> = {
	[BOOLEAN]: BooleanDescendingIcon,
	[NUMERIC]: NumericalDescendingIcon,
	[STRING]: AlphabeticalDescendingIcon,
};

/** return an icon based on value type and the sorting order */
export function getSortingIcon(valueType: string, descending: boolean): FunctionComponent {
	const icons = descending ? DESCENDING_ICONS : ASCENDING_ICONS;
	const type = xml.attributeTypeIsNumeric(valueType) ? NUMERIC : valueType;
	return icons[type] || icons[STRING];
}